var render = function () {
  var _class;

  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    class: (_class = {}, _class[_vm.$style.container] = true, _class[_vm.$style.active] = _vm.isActive, _class),
    on: {
      "click": function click($event) {
        return _vm.$emit('click');
      }
    }
  }, [_c('div', {
    class: _vm.$style.wrapper
  }, [_c('div', {
    directives: [{
      name: "m-r",
      rawName: "v-m-r",
      value: 20,
      expression: "20"
    }, {
      name: "d-flex",
      rawName: "v-d-flex"
    }, {
      name: "justify",
      rawName: "v-justify",
      value: {
        content: 'center'
      },
      expression: "{ content: 'center' }"
    }],
    class: [_vm.$style.logo]
  }, [_c('base-icon', {
    directives: [{
      name: "color",
      rawName: "v-color:dark-blue-2",
      arg: "dark-blue-2"
    }],
    attrs: {
      "name": "finance_wallet"
    }
  })], 1), _c('div', {
    class: _vm.$style.content
  }, [_c('p', {
    class: _vm.$style.title,
    domProps: {
      "textContent": _vm._s(_vm.wallet.hash)
    }
  }), _c('p', {
    class: _vm.$style.description,
    domProps: {
      "textContent": _vm._s(_vm.description)
    }
  })])]), _vm.$scopedSlots.hasOwnProperty('action') ? _c('div', {
    directives: [{
      name: "d-flex",
      rawName: "v-d-flex"
    }],
    class: _vm.$style.action
  }, [_vm._t("action")], 2) : _vm._e()]);
}
var staticRenderFns = []

export { render, staticRenderFns }